import * as Sentry from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import 'react-dropdown-tree-select/dist/styles.css';
import 'react-photo-view/dist/react-photo-view.css';
import "react-datepicker/dist/react-datepicker.css";
import { Provider } from 'react-redux';
import { CookiesProvider } from 'react-cookie';
// Redux
// https://github.com/rt2zz/redux-persist
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserTracing } from '@sentry/tracing';
// Axios
import axios from 'axios';
import { Chart, registerables } from 'chart.js';
import { IPLoading } from 'src/components';
// Apps
import { App } from './App';

/**
 * TIP: Replace this style import with dark styles to enable dark mode
 *
 * import './_metronic/assets/sass/style.dark.scss'
 **/
import './_metronic/assets/sass/style.scss';
import { MetronicI18nProvider } from './_metronic/i18n/Metronici18n';
import * as _redux from './services';
import store, { persistor } from './services/redux/app/Store';

//Sentry
Sentry.init({
  dsn: 'https://2587d2cf13954ae09a9c6a3005bb14b7@o1303688.ingest.sentry.io/6618826',
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env;
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */

// /* const mock = */ _redux.mockAxios(axios);
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
_redux.setupAxios(axios, store);

Chart.register(...registerables);

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);

root.render(
  <MetronicI18nProvider>
    <Provider store={store}>
      {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
      <PersistGate
        persistor={persistor}
        loading={
          <div className="card d-flex align-items-center bg-transparent w-100 shadow-none position-absolute bottom-0">
            <div className="card-body">
              <IPLoading />
            </div>
          </div>
        }
      >
        <CookiesProvider>
          <App basename={PUBLIC_URL} />
        </CookiesProvider>
      </PersistGate>
    </Provider>
  </MetronicI18nProvider>
);
